<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <defs>
      <mask v-if="stop" :id="`stopmask_${id}`">
        <rect x="0" y="0" width="100%" height="100%" fill="#fff" />
        <rect
          width="5.293"
          height="27.447"
          transform="translate(19.995 2) rotate(45)"
          fill="#000"
          stroke-miterlimit="10"
          stroke-width="1"
        />
      </mask>
      <mask v-if="gnavi || clock" :id="`mask_${id}`">
        <rect x="0" y="0" width="100%" height="100%" fill="#fff" />
        <template v-if="gnavi">
          <path
            d="M14 17.93a1.47 1.47 0 0 1-.43-1.3 1.58 1.58 0 0 1 .63-1.08l3.22-2.47c.14.14 0 .26.14.39s.26 0 .39.16 0 .25.12.39.25 0 .38.16 0 .25.12.38.26 0 .39.18l-2.65 2.09L19 19.48l-1.7 1.67-3.3-3.21M20.55 14a.79.79 0 1 0-1.55-.15.79.79 0 0 0 .72.85.8.8 0 0 0 .83-.7z"
            fill="#000"
          />
          <path d="M20.55 16.05a.8.8 0 0 0-.73-.85.793.793 0 0 0-.13 1.58.8.8 0 0 0 .86-.73z" fill="#000" />
        </template>
        <circle v-if="clock" cx="17.06" cy="17.11" r="6.95" fill="#000" />
      </mask>
    </defs>
    <g :mask="stop ? `url(#stopmask_${id})` : false">
      <g :mask="gnavi || clock ? `url(#mask_${id})` : false">
        <path
          v-if="blank"
          d="M19,4H18V2H16V4H8V2H6V4H5A2,2,0,0,0,3,6V20a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V6A2,2,0,0,0,19,4Zm0,16H5V9H19Z"
        />
        <path
          v-else
          d="M19,4H18V2H16V4H8V2H6V4H5A2.006,2.006,0,0,0,3,6V20a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V6A2.006,2.006,0,0,0,19,4Zm0,16H5V9H19ZM7,11h5v5H7Z"
        />
        <circle v-if="gnavi" cx="17.06" cy="17.11" r="6.95" />
      </g>
      <g v-if="clock">
        <path d="M33.837,33.264V29.037h1.345v3.53l3.028,1.8L37.53,35.48Z" transform="translate(-17.5 -15.5)" />
        <path
          d="M25.571,21a6.578,6.578,0,1,0,6.584,6.578A6.574,6.574,0,0,0,25.571,21Zm.007,11.481a4.9,4.9,0,1,1,4.9-4.9A4.909,4.909,0,0,1,25.578,32.481Z"
          transform="translate(-8.5 -10.5)"
        />
      </g>
    </g>
    <rect
      v-if="stop"
      width="2.3"
      height="24.4"
      transform="translate(19.995 4.115) rotate(45)"
      fill="#c40000"
      stroke-miterlimit="10"
      stroke-width="1"
    />
  </svg>
</template>

<script>
export default {
  name: 'CalendarIcon',
  props: {
    /** 空白のカレンダーを表示します */
    blank: Boolean,
    /** ぐるなびマークを表示します */
    gnavi: Boolean,
    /** 時計マークを表示します */
    clock: Boolean,
    /** 赤い斜線を表示します */
    stop: Boolean,
  },
  computed: {
    id() {
      return Math.random()
        .toString(36)
        .slice(-8)
    },
  },
}
</script>
